import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dialog } from 'primereact/dialog';
import api from '../../services/api';

export default function ApproveLeaves() {
  const [leaves, setLeaves] = useState([]);
  const [selectedLeaveId, setSelectedLeaveId] = useState(null);
  const [rejectionNote, setRejectionNote] = useState('');
  const [rejectVisible, setRejectVisible] = useState(false);

  const fetchLeaves = async () => {
    const res = await api.get('/leave-requests/pending');
    setLeaves(res.data);
  };

  useEffect(() => {
    fetchLeaves();
  }, []);

  const handleApprove = async (id) => {
    await api.put(`/leave-requests/${id}/approve`);
    fetchLeaves();
  };

  const handleReject = async () => {
    if (!rejectionNote.trim()) return;
    await api.put(`/leave-requests/${selectedLeaveId}/reject`, null, {
      params: { note: rejectionNote },
    });
    setRejectVisible(false);
    setRejectionNote('');
    setSelectedLeaveId(null);
    fetchLeaves();
  };

  const openRejectModal = (id) => {
    setSelectedLeaveId(id);
    setRejectionNote('');
    setRejectVisible(true);
  };

  const actionBodyTemplate = (rowData) => (
    <div className="flex flex-column gap-2">
      <Button
        icon="pi pi-check"
        className="p-button-success"
        onClick={() => handleApprove(rowData.id)}
      />
      <Button
        icon="pi pi-times"
        className="p-button-danger"
        onClick={() => openRejectModal(rowData.id)}
      />
    </div>
  );

  return (
    <div>
      <h3>İzin Talepleri (Onay Bekleyen)</h3>
      <DataTable value={leaves} paginator rows={5} stripedRows>
        <Column field="user.first_name" header="Ad" />
        <Column field="user.last_name" header="Soyad" />
        <Column field="leave_type.name" header="İzin Türü" />
        <Column field="start_date" header="Başlangıç" />
        <Column field="end_date" header="Bitiş" />
        <Column field="reason" header="Açıklama" />
        <Column header="İşlem" body={actionBodyTemplate} />
      </DataTable>
      <Dialog
        header="Reddetme Notu"
        visible={rejectVisible}
        onHide={() => setRejectVisible(false)}
        modal
      >
        <div className="flex flex-column gap-3">
          <InputTextarea
            value={rejectionNote}
            onChange={(e) => setRejectionNote(e.target.value)}
            placeholder="Reddetme Notu"
            autoResize
            rows={3}
            cols={40}
          />
          <div className="flex justify-content-end gap-2">
            <Button label="Vazgeç" className="p-button-text" onClick={() => setRejectVisible(false)} />
            <Button
              label="Reddet"
              className="p-button-danger"
              onClick={handleReject}
              disabled={!rejectionNote.trim()}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
}
